<template>

  <v-list two-line>
    <v-subheader>Flight arrival</v-subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Scheduled
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ value.scheduledTimeArrival | localMoment('YYYY-MM-DD HH:mm') }}<span class="error--text" v-if="value.actualArrApIata !== value.arrApIata"> {{value.arrApIata}}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="estArr">
      <v-list-item-content>
        <v-list-item-title>
          Estimated
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ estArr | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="actArr">
      <v-list-item-content>
        <v-list-item-title>
          Actual
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ actArr | localMoment('YYYY-MM-DD HH:mm') }}<span class="error--text" v-if="value.actualArrApIata !== value.arrApIata"> {{value.actualArrApIata}}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Stand
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.arrivalStand">
            {{ value.arrivalStand }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Gate
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.arrivalGate">
            {{ value.arrivalGate }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>

export default {
  name: 'FlightInfoArrival',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
    estArr() {
      return (this.value.scheduledTimeArrival !== this.value.timeArrival && !this.actArr) ? this.value.timeArrival : undefined
    },
    actArr() {
      return this.value.onBlockTime
    }
  }
}
</script>
